
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [{
label: '问题解释',
value: this.$route.params.CZN_Content
}]
}
}



// WEBPACK FOOTER //
// ./src/components/CustomsGuideDetail.vue